import { GroupDividerLayout } from '@/components/table/group-divider-layout.js';
import { SchoolNameGroupKey } from '@/lib/table-grouping-utils.js';

interface SchoolNameDividerProps {
  groupKey: SchoolNameGroupKey;
  rowCount: number;
}

export function SchoolNameDivider({ groupKey, rowCount }: SchoolNameDividerProps) {
  return <GroupDividerLayout rowCount={rowCount}>{groupKey.schoolName}</GroupDividerLayout>;
}
